import { cryptocurrencyExchanges } from "../../components/ui/forms/selectOptionData";

/**
 * Get exchange API code from exchange value
 * @param {string} exchangeValue - Exchange value (e.g., "coinbase")
 * @returns {string|null} Exchange code (e.g., "CB") or null if not found
 */
export function getExchangeCode(exchangeValue) {
  const exchanges = cryptocurrencyExchanges();
  const exchange = exchanges.find(ex => ex.value === exchangeValue?.toLowerCase());
  return exchange?.code || null;
}

/**
 * Get exchange value from API code
 * @param {string} exchangeCode - Exchange API code (e.g., "CB")
 * @returns {string|null} Exchange value (e.g., "coinbase") or null if not found
 */
export function getExchangeValue(exchangeCode) {
  const exchanges = cryptocurrencyExchanges();
  const exchange = exchanges.find(ex => ex.code === exchangeCode?.toUpperCase());
  return exchange?.value || null;
}

/**
 * Get exchange label from value
 * @param {string} exchangeValue - Exchange value (e.g., "coinbase")
 * @returns {string|null} Exchange label (e.g., "Coinbase") or null if not found
 */
export function getExchangeLabel(exchangeValue) {
  const exchanges = cryptocurrencyExchanges();
  const exchange = exchanges.find(ex => ex.value === exchangeValue?.toLowerCase());
  return exchange?.label || null;
}

/**
 * Get exchange configuration
 * @param {string} exchangeValue - Exchange value (e.g., "coinbase")
 * @returns {object|null} Exchange config object or null if not found
 */
export function getExchangeConfig(exchangeValue) {
  const exchanges = cryptocurrencyExchanges();
  return exchanges.find(ex => ex.value === exchangeValue?.toLowerCase()) || null;
}
